<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Parcours des Disciples d'Emmaüs" />
            <ParcoursDisciples/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import ParcoursDisciples from './ParcoursDisciples.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        ParcoursDisciples,
        FooterComp,
    }
}
</script>